/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPromoTypeTermsFieldSchema {
  /** Тип поля **/
  type: EType;
  /** Тип акции **/
  value: EValue[];
}

export enum EType {
  /** Поле с одним значением **/
  'Term' = 'term',
  /** Поле со списком значений **/
  'Terms' = 'terms',
}
export enum EValue {
  /** Бонусы **/
  'Bonus' = 'bonus',
  /** Циан ипотека **/
  'CianMortgage' = 'cianMortgage',
  /** Скидки **/
  'Discount' = 'discount',
  /** Рассрочка **/
  'Installment' = 'installment',
  /** Материнский капитал **/
  'MaternalCapital' = 'maternalCapital',
  /** Военная ипотека **/
  'Military' = 'military',
  /** Ипотека **/
  'Mortgage' = 'mortgage',
}
